/* Bundle default selection.

   Clicks the chosen card once on load and lets Horizon's own variant picker do
   the rest — price, hidden variant id, URL. Nothing is forced server-side, so
   the form can never end up out of sync with what the customer sees.

   Skipped when the URL already carries ?variant=, so shared and ad links still
   land on the variant they name. */

(function () {
  function applyDefaults() {
    if (new URLSearchParams(window.location.search).has('variant')) return;

    document.querySelectorAll('[data-bundle-default]').forEach(function (picker) {
      var position = Number(picker.dataset.bundleDefault);
      if (!position) return;

      var radios = picker.querySelectorAll('.bundle-card-input');
      var target = radios[position - 1];

      // Nothing to do if it is already the selected one, or sold out.
      if (!target || target.checked) return;
      if (target.getAttribute('aria-disabled') === 'true') return;

      target.click();
    });
  }

  // Runs once. A section re-render does not fire this again, so a customer's
  // own choice is never overridden afterwards.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDefaults);
  } else {
    applyDefaults();
  }
})();